"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.combinedReducersBase = void 0;
var currentWorkspaceUserReducerBase_1 = require("./reducers/currentWorkspaceUserReducerBase");
var currentWorkspaceReducerBase_1 = require("./reducers/currentWorkspaceReducerBase");
var workspaceReducerBase_1 = require("./reducers/workspaceReducerBase");
var cookieStorageReducerBase_1 = require("./reducers/cookieStorageReducerBase");
var currentLocationReducerBase_1 = require("./reducers/currentLocationReducerBase");
var sessionStorageReducerBase_1 = require("./reducers/sessionStorageReducerBase");
var togglesReducerBase_1 = require("./reducers/togglesReducerBase");
var currentUserIdReducerBase_1 = require("./reducers/currentUserIdReducerBase");
var currentUserReducerBase_1 = require("./reducers/currentUserReducerBase");
var windowMetaReducerBase_1 = require("./reducers/windowMetaReducerBase");
var currentUnscopeUserReducerBase_1 = require("./reducers/currentUnscopeUserReducerBase");
var alertMessageReducerBase_1 = require("./reducers/alertMessageReducerBase");
var currentCustomClaimReducerBase_1 = require("./reducers/currentCustomClaimReducerBase");
var inviteReducerBase_1 = require("./reducers/inviteReducerBase");
var uploadedFilesReducerBase_1 = require("./reducers/uploadedFilesReducerBase");
var uploadReducer_1 = require("./reducers/uploadReducer");
var statReducerBase_1 = require("./reducers/statReducerBase");
var pageReducerBase_1 = require("./reducers/pageReducerBase");
var currentWorkspaceStatReducerBase_1 = require("./reducers/currentWorkspaceStatReducerBase");
var currentWorkspaceIdReducerBase_1 = require("./reducers/currentWorkspaceIdReducerBase");
var currentErrorReducerBase_1 = require("./reducers/currentErrorReducerBase");
var elementReducerBase_1 = require("./reducers/elementReducerBase");
var workingReducerBase_1 = require("./reducers/workingReducerBase");
exports.combinedReducersBase = {
    alertMessage: alertMessageReducerBase_1.alertMessageReducerBase,
    cookieStorage: cookieStorageReducerBase_1.cookieStorageReducerBase,
    currentCustomClaim: currentCustomClaimReducerBase_1.currentCustomClaimReducerBase,
    currentLocation: currentLocationReducerBase_1.currentLocationReducerBase,
    currentUnscopeUser: currentUnscopeUserReducerBase_1.currentUnscopeUserReducerBase,
    currentUser: currentUserReducerBase_1.currentUserReducerBase,
    currentUserId: currentUserIdReducerBase_1.currentUserIdReducerBase,
    currentWorkspaceStat: currentWorkspaceStatReducerBase_1.currentWorkspaceStatReducerBase,
    currentWorkspaceId: currentWorkspaceIdReducerBase_1.currentWorkspaceIdReducerBase,
    currentWorkspace: currentWorkspaceReducerBase_1.currentWorkspaceReducerBase,
    currentWorkspaceUser: currentWorkspaceUserReducerBase_1.currentWorkspaceUserReducerBase,
    currentError: currentErrorReducerBase_1.currentErrorReducerBase,
    invites: inviteReducerBase_1.inviteReducerBase,
    page: pageReducerBase_1.pageReducerBase,
    sessionStorage: sessionStorageReducerBase_1.sessionStorageReducerBase,
    stat: statReducerBase_1.statReducerBase,
    toggles: togglesReducerBase_1.togglesReducerBase,
    uploadedFiles: uploadedFilesReducerBase_1.uploadedFilesReducerBase,
    uploads: uploadReducer_1.uploadReducer,
    windowMeta: windowMetaReducerBase_1.windowMetaReducerBase,
    workspaces: workspaceReducerBase_1.workspaceReducerBase,
    elements: elementReducerBase_1.elementReducerBase,
    working: workingReducerBase_1.workingReducerBase,
};
